import * as DatasetHelper from '../dataset-helper';

/**
 * {@code Accumulate} the data in the specified field.
 */
export default function calculate(statistics, dataset, referenceSitesHash, selectedSiteIds,
                                  categoryFieldId, calculationStepDefn) {

  // Identify the accumulator field.
  const accumulatorField = DatasetHelper.findField(dataset, calculationStepDefn.fieldId);
  const accumulatorFieldName = accumulatorField.fieldName;
  const isMaxOnly = calculationStepDefn.maxOnly;
  const propertyPrefix = calculationStepDefn.propertyPrefix;
  const onSelectedSitesProperty = propertyPrefix + 'OnSelectedSites';
  const onSelectableSitesProperty = propertyPrefix + 'OnSelectableSites';
  const onAllSitesProperty = propertyPrefix + 'OnAllSites';

  // Identify the category field.
  const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
  const categoryFieldName = categoryField.fieldName;

  // Define the field-level variables.
  let totalOnSelectedSites = 0.0;
  let totalOnSelectableSites = 0.0;
  let totalOnAllSites = 0.0;

  // Only attempt to populate if a dataset is provided.
  if (dataset) {

    // Loop through every site.
    Object.keys(referenceSitesHash).forEach((siteId) => {
      const site = referenceSitesHash[siteId];
      const isSiteSelected = selectedSiteIds.includes(siteId);
      const accumulatorFieldValue = site.data[accumulatorFieldName] || 0.0;
      const categoryFieldValue = site.data[categoryFieldName];

      // Only process if both the category field value and the accumulator field value exist.
      // Note the '!!' means, 'not not exists', which tests if it exists (positive evaluation).
      if (!!categoryFieldValue && !isNaN(accumulatorFieldValue)) {

        // Ensure the category result object exists.
        if (!statistics[categoryFieldValue]) {
          statistics[categoryFieldValue] = {};
        }
        const categoryResult = statistics[categoryFieldValue];
        categoryResult[onSelectedSitesProperty] = categoryResult[onSelectedSitesProperty] || 0.0;
        categoryResult[onSelectableSitesProperty] = categoryResult[onSelectableSitesProperty] || 0.0;
        categoryResult[onAllSitesProperty] = categoryResult[onAllSitesProperty] || 0.0;

        // Accumulate as required.
        if (isSiteSelected) {
          if (isMaxOnly) {
            // Use only max value.
            if (accumulatorFieldValue > categoryResult[onSelectedSitesProperty]) {
              categoryResult[onSelectedSitesProperty] = accumulatorFieldValue;
            }
          } else {
            // Accumulate values.
            categoryResult[onSelectedSitesProperty] =
              categoryResult[onSelectedSitesProperty] + accumulatorFieldValue;
          }
        }
        if (site.isSelectable) {
          if (isMaxOnly) {
            // Use only max value.
            if (accumulatorFieldValue > categoryResult[onSelectableSitesProperty]) {
              categoryResult[onSelectableSitesProperty] = accumulatorFieldValue;
            }
          } else {
            // Accumulate values.
            categoryResult[onSelectableSitesProperty] =
              categoryResult[onSelectableSitesProperty] + accumulatorFieldValue;
          }
        }
        if (isMaxOnly) {
          // Use only max value.
          if (accumulatorFieldValue > categoryResult[onAllSitesProperty]) {
            categoryResult[onAllSitesProperty] = accumulatorFieldValue;
          }
        } else {
          categoryResult[onAllSitesProperty] =
            categoryResult[onAllSitesProperty] + accumulatorFieldValue;
        }

      }

    });

    // Calculate field-level totals.
    const categories = categoryField.categories;
    categories.forEach(category => {
      const categoryResult = statistics[category.value];
      totalOnSelectedSites = totalOnSelectedSites + categoryResult[onSelectedSitesProperty];
      totalOnSelectableSites = totalOnSelectableSites + categoryResult[onSelectableSitesProperty];
      totalOnAllSites = totalOnAllSites + categoryResult[onAllSitesProperty];
    });

  }

  // Assign the totals to the field-level statistics object.
  statistics[onSelectedSitesProperty] = totalOnSelectedSites;
  statistics[onSelectableSitesProperty] = totalOnSelectableSites;
  statistics[onAllSitesProperty] = totalOnAllSites;

}



// WEBPACK FOOTER //
// ./src/app/utils/calculators/accumulation-calculator.js